import { Truck, Mail, Phone, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#0A0A0A] text-white relative overflow-hidden grain">
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-white flex items-center justify-center">
              <Truck size={18} className="text-[#FF4500]" strokeWidth={2} />
            </div>
            <span className="font-display font-bold text-lg">ADTRAX LOGISTICS</span>
          </div>
          <p className="mt-6 text-white/70 max-w-md text-base leading-relaxed">
            A truck dispatching service based in Euless, Texas. We keep owner-operators and small
            carriers loaded, paid, and moving across the lower 48.
          </p>
          <p className="mt-8 font-mono-label text-xs text-[#FF4500]">DISPATCHING NATIONWIDE · USA</p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-label text-xs text-white/50">Reach Us</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-[#FF4500]"/> <a href="tel:+12145545884" className="hover:text-[#FF4500]" data-testid="footer-phone">214-554-5884</a></li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-[#FF4500]"/> <a href="mailto:info@adtraxlogistics.com" className="hover:text-[#FF4500] break-all" data-testid="footer-email">info@adtraxlogistics.com</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#FF4500]"/> <span>501 Arbor Creek Dr<br/>Euless, TX 76039</span></li>
            <li className="flex items-start gap-2"><Clock size={16} className="mt-0.5 text-[#FF4500]"/> <span>Dispatch &amp; office<br/>Mon–Fri 8:00–5:00 CT</span></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono-label text-xs text-white/50">Dispatching For</p>
          <ul className="mt-4 grid grid-cols-2 gap-3 text-sm">
            <li>Dry Van</li>
            <li>Reefer</li>
            <li>Flatbed</li>
            <li>Step Deck</li>
            <li>Power Only</li>
            <li>Hotshot</li>
          </ul>
          <p className="mt-8 font-mono-label text-xs text-white/50">What We Handle</p>
          <ul className="mt-3 text-sm space-y-1 text-white/80">
            <li>· Load sourcing &amp; rate negotiation</li>
            <li>· Route planning &amp; fuel optimization</li>
            <li>· Rate confirmations, BOLs, invoicing</li>
            <li>· 24/7 driver–broker–shipper comms</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between text-xs text-white/50">
          <p>© {new Date().getFullYear()} Adtrax Logistics. All rights reserved.</p>
          <p className="font-mono-label">TRUCK DISPATCHING · UNITED STATES</p>
        </div>
      </div>
    </footer>
  );
}
